// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Assets/Images/aboutus-hreo-bg.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.expertiseparagraph p {
  color: white;
  margin-bottom: 1.4rem;
  font-size: 13px;
}
.expertise {
  padding: 4rem;
}
.expertiseparagraph p:first-child {
  color: #eaad11;
  font-size: 10px;
}
/* button {
  width: 50%;
} */
.expertiseparagraph {
  width: 20%;
}
.professional {
  padding-left: 3rem;
  width: 60%;
}
.workspace1 {
  margin-top: 0.2rem;
  /* width: 75%; */
}
.vatworkspace {
  background-color: transparent;
}

.subsidiary{
  background-color: var(--dark--green);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  height: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 80% 5%;
  padding: 4rem 0rem 0rem 0rem;
}

.subsidiary_card{
  padding: 0 20px;
}

.vatpay_container{
  background-color:#012101 ;
}

.workspace {
  justify-content: center;
  align-items: center;
}

.subsidiary_btn{
  width: 50% !important;
}


.subsidiary_expertise_texth3{
  font-size: 30px !important;
  font-weight: 700 !important;
  line-height: 44px !important;
}

.subsidiary_expertise_text_1{
  font-size: 16px !important;
  font-weight: 400 !important;
  line-height: 24.46px !important;
  width: 350px !important;
}

/* .professional{
  border: 1px solid red;
  margin: auto !important;

} */

@media screen and (max-width: 1250px) {
  .subsidiary_img{
    width: 100% !important;
    object-fit: contain !important;
  }

  .subsidiary_expertise_texth3{
    font-size: 28px !important;
    font-weight: 700 !important;
    line-height: 44px !important;
  }
  
  .subsidiary_expertise_text_1{
    font-size: 16px !important;
    font-weight: 400 !important;
    line-height: 24.46px !important;
    width: 300px !important;
  }
}

@media screen and (max-width: 900px) {
  .subsidiary_img{
    width: 100% !important;
  }
  .subsidiary_btn{
    width: 60% !important;
  }

  .subsidiary_expertise_texth3{
    font-size: 23px !important;
    font-weight: 700 !important;
    line-height: 44px !important;
  }
  
  .subsidiary_expertise_text_1{
    font-size: 14px !important;
    font-weight: 400 !important;
    line-height: 24.46px !important;
    width: 220px !important;
  }
  .professional{
  /* border: 1px solid red; */
  margin: auto !important;

}

}

@media screen and (max-width: 700px) {

  .subsidiary_card p{
    padding-top: 30px;
  }

  .workspace {
    display: flex;
    flex-direction: column-reverse;
  }
  .expertiseparagraph {
    margin-left: 0rem;
    width: 100%;
  }
  /* button {
    width: 50%;
  } */
  .workspace1 {
    margin-top: 1.2rem;
    margin-bottom: 2rem;
    width: 100%;
  }
  .colors {
    height: 1%;
  }
  .expertisecontainer {
    flex-direction: column-reverse;
  }
  .expertise {
    padding: 1rem;
  }
  .colors::after {
    width: 100%;
    height: 2%;
  }
  .professional {
    padding-left: 1rem;
    width: 100%;
  }

  .subsidiary_expertise_texth3{
    font-size: 24px !important;
    font-weight: 700 !important;
    line-height: 44px !important;
  }
  
  .subsidiary_expertise_text_1{
    font-size: 16px !important;
    font-weight: 400 !important;
    line-height: 24.46px !important;
    width: 100% !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Subsidiaries.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;;GAEG;AACH;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,yDAA2D;EAC3D,YAAY;EACZ,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;;AAGA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;;;;GAIG;;AAEH;EACE;IACE,sBAAsB;IACtB,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,+BAA+B;IAC/B,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,+BAA+B;IAC/B,uBAAuB;EACzB;EACA;EACA,2BAA2B;EAC3B,uBAAuB;;AAEzB;;AAEA;;AAEA;;EAEE;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,8BAA8B;EAChC;EACA;IACE,iBAAiB;IACjB,WAAW;EACb;EACA;;KAEG;EACH;IACE,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,8BAA8B;EAChC;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,+BAA+B;IAC/B,sBAAsB;EACxB;AACF","sourcesContent":[".expertiseparagraph p {\n  color: white;\n  margin-bottom: 1.4rem;\n  font-size: 13px;\n}\n.expertise {\n  padding: 4rem;\n}\n.expertiseparagraph p:first-child {\n  color: #eaad11;\n  font-size: 10px;\n}\n/* button {\n  width: 50%;\n} */\n.expertiseparagraph {\n  width: 20%;\n}\n.professional {\n  padding-left: 3rem;\n  width: 60%;\n}\n.workspace1 {\n  margin-top: 0.2rem;\n  /* width: 75%; */\n}\n.vatworkspace {\n  background-color: transparent;\n}\n\n.subsidiary{\n  background-color: var(--dark--green);\n  background-image: url(../Assets/Images/aboutus-hreo-bg.svg);\n  height: 100%;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: 80% 5%;\n  padding: 4rem 0rem 0rem 0rem;\n}\n\n.subsidiary_card{\n  padding: 0 20px;\n}\n\n.vatpay_container{\n  background-color:#012101 ;\n}\n\n.workspace {\n  justify-content: center;\n  align-items: center;\n}\n\n.subsidiary_btn{\n  width: 50% !important;\n}\n\n\n.subsidiary_expertise_texth3{\n  font-size: 30px !important;\n  font-weight: 700 !important;\n  line-height: 44px !important;\n}\n\n.subsidiary_expertise_text_1{\n  font-size: 16px !important;\n  font-weight: 400 !important;\n  line-height: 24.46px !important;\n  width: 350px !important;\n}\n\n/* .professional{\n  border: 1px solid red;\n  margin: auto !important;\n\n} */\n\n@media screen and (max-width: 1250px) {\n  .subsidiary_img{\n    width: 100% !important;\n    object-fit: contain !important;\n  }\n\n  .subsidiary_expertise_texth3{\n    font-size: 28px !important;\n    font-weight: 700 !important;\n    line-height: 44px !important;\n  }\n  \n  .subsidiary_expertise_text_1{\n    font-size: 16px !important;\n    font-weight: 400 !important;\n    line-height: 24.46px !important;\n    width: 300px !important;\n  }\n}\n\n@media screen and (max-width: 900px) {\n  .subsidiary_img{\n    width: 100% !important;\n  }\n  .subsidiary_btn{\n    width: 60% !important;\n  }\n\n  .subsidiary_expertise_texth3{\n    font-size: 23px !important;\n    font-weight: 700 !important;\n    line-height: 44px !important;\n  }\n  \n  .subsidiary_expertise_text_1{\n    font-size: 14px !important;\n    font-weight: 400 !important;\n    line-height: 24.46px !important;\n    width: 220px !important;\n  }\n  .professional{\n  /* border: 1px solid red; */\n  margin: auto !important;\n\n}\n\n}\n\n@media screen and (max-width: 700px) {\n\n  .subsidiary_card p{\n    padding-top: 30px;\n  }\n\n  .workspace {\n    display: flex;\n    flex-direction: column-reverse;\n  }\n  .expertiseparagraph {\n    margin-left: 0rem;\n    width: 100%;\n  }\n  /* button {\n    width: 50%;\n  } */\n  .workspace1 {\n    margin-top: 1.2rem;\n    margin-bottom: 2rem;\n    width: 100%;\n  }\n  .colors {\n    height: 1%;\n  }\n  .expertisecontainer {\n    flex-direction: column-reverse;\n  }\n  .expertise {\n    padding: 1rem;\n  }\n  .colors::after {\n    width: 100%;\n    height: 2%;\n  }\n  .professional {\n    padding-left: 1rem;\n    width: 100%;\n  }\n\n  .subsidiary_expertise_texth3{\n    font-size: 24px !important;\n    font-weight: 700 !important;\n    line-height: 44px !important;\n  }\n  \n  .subsidiary_expertise_text_1{\n    font-size: 16px !important;\n    font-weight: 400 !important;\n    line-height: 24.46px !important;\n    width: 100% !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
